// extracted by mini-css-extract-plugin
export var animationContainer = "_eg-0";
export var asteriskIcon = "_eg-8";
export var conversationLeftSection = "_eg-4";
export var conversationListItem = "_eg-3";
export var conversationMiddleSection = "_eg-5";
export var conversationRightSection = "_eg-6";
export var detailsContent = "_eg-1";
export var listContainer = "_eg-7";
export var modalContent = "_eg-2";